import i18next from 'i18next';
import Button from '../../Components/Button/Button';
import ButtonAlt from '../../Components/Button/ButtonAlt';
import HtmlNode from '../../Components/Extension/HtmlNode';

const CONFIRM_CLOSE_NODE = 'confirm-close-node';
const ABORT_CLOSE_NODE = 'abort-close-node';

interface ConfirmCloseProps {
  readonly onConfirmClose: () => void;
  readonly onAbortClose: () => void;
}

class ConfirmClose extends HtmlNode {
  private readonly props: ConfirmCloseProps;
  constructor(element: HTMLElement, props: ConfirmCloseProps) {
    super(element);
    this.props = props;

    this.render();
  }

  render() {
    const { onConfirmClose, onAbortClose } = this.props;

    this.node.innerHTML = `
      <div class="waykevaluation-stack waykevaluation-stack--3">
        <div class="waykevaluation-stack waykevaluation-stack--2">
          <div class="waykevaluation-hstack waykevaluation-hstack--spacing-2 waykevaluation-hstack--align-center">
            <div class="waykevaluation-hstack__item" aria-hidden="true">
              <div class="waykevaluation-icon-backdrop waykevaluation-icon-backdrop--error">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 16 16"
                  class="waykevaluation-icon"
                  data-icon="Exclamation mark"
                >
                  <path d="M7.1 9.6 6.7 2h2.7L9 9.6H7.1zM8 11c-.8 0-1.5.7-1.5 1.5S7.2 14 8 14s1.5-.7 1.5-1.5S8.8 11 8 11z" />
                </svg>
              </div>
            </div>
            <div class="waykevaluation-hstack__item">
              <h3 class="waykevaluation-heading waykevaluation-heading--3 waykevaluation-no-margin">
                ${i18next.t('confirmClose.heading')}
              </h3>
            </div>
          </div>
        </div>
        <div class="waykevaluation-stack waykevaluation-stack--2">
          <div class="waykevaluation-content">
            <p class="waykevaluation-content__p">${i18next.t('confirmClose.body')}</p>
          </div>
        </div>
      </div>
      <div class="waykevaluation-stack waykevaluation-stack--3">
        <div class="waykevaluation-stack waykevaluation-stack--1" id="${ABORT_CLOSE_NODE}"></div>
        <div class="waykevaluation-stack waykevaluation-stack--1" id="${CONFIRM_CLOSE_NODE}"></div>
      </div>
    `;

    new Button(this.node.querySelector<HTMLDivElement>(`#${ABORT_CLOSE_NODE}`), {
      title: i18next.t('confirmClose.buttonContinueText'),
      onClick: () => onAbortClose(),
    });

    new ButtonAlt(this.node.querySelector<HTMLDivElement>(`#${CONFIRM_CLOSE_NODE}`), {
      title: i18next.t('confirmClose.buttonCancelText'),
      onClick: () => onConfirmClose(),
    });
  }
}

export default ConfirmClose;
